/*
 *  This file app.component.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";
import { AuthenticateUserComponent } from './global/components/authenticate-user/authenticate-user.component';
import { SharedService } from './global/services/shared.service';
import { Title } from '@angular/platform-browser';
import { AuthService } from './global/services/auth-service';
import { TLoginTokenResponse } from './global/models/common.models';
import { environment } from 'src/environments/environment';
export const commonPasswords = [
      "password",
      "123456",
      "12345678",
      "qwerty",
      "abc123",
      "monkey",
      "1234567",
      "letmein",
      "trustno1",
      "dragon",
      "baseball",
      "111111",
      "iloveyou",
      "master",
      "sunshine",
      "ashley",
      "bailey",
      "passw0rd",
      "shadow",
      "123123",
      "654321",
      "superman",
      "qazwsx",
      "michael",
      "Football",
      "welcome",
      "jesus",
      "ninja",
      "mustang",
      "password1",
      "123456789",
      "adobe123[a]",
      "admin",
      "1234567890",
      "photoshop[a]",
      "1234",
      "12345",
      "princess",
      "azerty",
      "access",
      "696969",
      "batman",
      "1qaz2wsx",
      "login",
      "qwertyuiop",
      "solo",
      "starwars",
      "121212",
      "flower",
      "hottie",
      "loveme",
      "zaq1zaq1",
      "hello",
      "freedom",
      "whatever",
      "666666",
      "!@#$%^&*",
      "charlie",
      "aa123456",
      "donald",
      "qwerty123",
      "Hrone@123",
      "1q2w3e4r",
      "654321",
      "555555",
      "lovely",
      "7777777",
      "888888",
      "123qwe",
      "Qwert123!@#",
      "Apple111!!!",
      "Google@123",
      "pray",
      "anan"
    ]
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  isLoggedIn = !!JSON.parse(localStorage.getItem('authlogin') ?? 'null');
  mobileDisclaimerShown = false;
  isMobile = true;
  showRedirectDialogForTeams = false;
  flashLoader = "/assets/images/init-loader-1.svg";
  flashLoaderGT = "assets/images/dynamic_images/loader-2.svg";
  @ViewChild('reauth') reauth!: AuthenticateUserComponent;
  title = 'app';
  public isShowingRouteLoadIndicator: boolean = false;
  isPageLoading: boolean = false;
  isTimeOut: boolean = false;
  isClientConfig = true;
  constructor(
    public router: Router,
    public _shared: SharedService,
    private readonly titleService: Title,
    private readonly _auth: AuthService,
  ) {
    window.addEventListener('online', () => {
      this._shared._httpService.isOnline = true;
    });
    window.addEventListener('offline', () => {
      this._shared._httpService.isOnline = false;
    });
    const isGTInstance = this._shared.isDeployedOnGT;
    localStorage.removeItem('analyticsReportAccessType');
    localStorage.removeItem('isRefreshingToken');
    localStorage.setItem('clientConfig', JSON.stringify(isGTInstance));
    localStorage.setItem('showMoveToArchieve', JSON.stringify(true));
    if (isGTInstance) {
      this.isClientConfig = JSON.parse(localStorage.getItem('clientConfig') ?? 'false');
    } else {
      this.isClientConfig = false
    }
    // no need to add this check as the first check already checks for presence of authlogin;
    const isTempPass = JSON.parse(localStorage.getItem('isTempPass') || 'false');
    if(isTempPass) {
       this._auth.logout();
      return;
    }
    if(this._auth.isAuthenticatedOrSSO()){
     this._auth.getRefreshTokenWithRefreshHeader().subscribe({
      next: (auth: TLoginTokenResponse) => {
        this._auth.isRefreshToken = false;
        this._auth.setLoginAuth(auth);
        this._shared.setRolloutCookie(auth);
        this._shared._globalState.getVersionDetails().subscribe({
          next: (response) => {
            this._shared._globalState.handleVersionDetails(response);
          }
        })
      },
      error: (error) => {
        this._auth.isRefreshToken = false;
        (error.status === 400 || error.status === 5999) && this._shared._httpService.isOnline && (window.location.pathname.includes("app") || this.router.url === '/') && this._auth.logout();
      }
    });
   }
  }



  ngOnInit() {
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.setAttribute("href", this._shared.companyDetails.favicon);
    }
    this.setTitle();
    this._shared.getAppVersion();
    this.router.events.subscribe(event => {
      this.navigationInterceptor(event);
    });

    this.getClientDomainValues();
  }


  ngAfterViewInit() {
    this.listenForLogout();
  }

  listenForLogout() {

    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage && event.key !== '_grecaptcha' && event.key != 'isAppLock' && event.key != 'remainingIdleTime') {
        const token = localStorage.getItem('authlogin');

        if (!token) {
          if (event.key !== 'upcomingLinkVerified' && event.key != 'test') {
            this._shared._httpService.updateSignalRAuthTokenSubject.next({ token: null, isLogout: true })
            if(environment.redirectToMicro){
              window.location.href = environment.loginRedirectUrl
             } else {
              this.router.navigate(['/login']);
             }
          }
          this.isLoggedIn = false;
        }
      }
    }, false);
  }


  navigationInterceptor(event: any): void {
    if (event.url && event.url.includes('app/notification/7')) {
          localStorage.setItem('resetPassword', event.url);
      }
    if (!localStorage.getItem('authlogin')) {
      if (event instanceof NavigationCancel) {
        localStorage.setItem('NAVIGATIONKEY', event.url);
      }
    }


    if (event instanceof NavigationStart) {
      const path = event.url ? event.url.toLowerCase() : '';
      const flag = path.includes('app/report/detail') || path.includes('app/payroll/processsalary')
        || path.includes('login') || path.includes('app/processattendance')
        || path.includes('app/candidate-list');
      this._shared.profile = event.url.split('/')[2];
      if (flag) {
        this.isPageLoading = true;
      }
    }
    if (event instanceof NavigationEnd || event instanceof NavigationCancel ||
      event instanceof NavigationError) {
      this.isPageLoading = false;
    }

  }

  getClientDomainValues() {
    const hd = localStorage.getItem('hashDomain');
    if (hd) {
      this._shared.getComapanyDetails(hd);
    } else {
      this._shared.getDefaultCompDetails();
    }

  }
  public setTitle() {
    this.titleService.setTitle(this._shared.companyDetails.title);
  }

  isMobileViewNew(isMobile: boolean): void {
    this.isMobile = isMobile;
    this.showRedirectDialogForTeams = !this._shared.isDeployedOnGT && isMobile;
  }

  closeMe(): void {
    this.mobileDisclaimerShown = true
  }
}
